import React from "react";
import styles from "./Footer.module.css";

const Footer = () => {
  return (
    <footer className={styles.footer}>
      <div>
        <span className={styles.footerText}>Equestrolog V1.4.X.1 ©2026</span>
      </div>
      <div>
        <a href="/help" className={styles.footerLink}>
          {/*i18n.t("Footer.ReportAnIssue")*/}
        </a>
      </div>
    </footer>
  );
};

export default Footer;
